import {
  BACKGROUND_PRESET_IDS,
  DEFAULT_BACKGROUND_PRESET_ID,
} from '../assets/backgrounds';

export const BACKGROUND_PREFERENCE_KEY = 'appBackgroundPreference';

export const DEFAULT_BACKGROUND_PREFERENCE = {
  type: 'default',
  color: '#101216',
  preset: DEFAULT_BACKGROUND_PRESET_ID,
};

const VALID_TYPES = new Set(['default', 'solid', 'preset']);
const VALID_PRESETS = new Set(BACKGROUND_PRESET_IDS);
const HEX_COLOR = /^#[0-9a-f]{6}$/i;

export const normalizeBackgroundPreference = (value) => ({
  type: VALID_TYPES.has(value?.type)
    ? value.type
    : DEFAULT_BACKGROUND_PREFERENCE.type,
  color: HEX_COLOR.test(value?.color || '')
    ? value.color
    : DEFAULT_BACKGROUND_PREFERENCE.color,
  preset: VALID_PRESETS.has(value?.preset)
    ? value.preset
    : DEFAULT_BACKGROUND_PREFERENCE.preset,
});

export const readBackgroundPreference = () => {
  try {
    const saved = window.localStorage.getItem(BACKGROUND_PREFERENCE_KEY);
    return saved
      ? normalizeBackgroundPreference(JSON.parse(saved))
      : DEFAULT_BACKGROUND_PREFERENCE;
  } catch {
    return DEFAULT_BACKGROUND_PREFERENCE;
  }
};

export const writeBackgroundPreference = (preference) => {
  const normalized = normalizeBackgroundPreference(preference);
  try {
    window.localStorage.setItem(
      BACKGROUND_PREFERENCE_KEY,
      JSON.stringify(normalized)
    );
  } catch {
    // localStorage 不可用时仍保留当前会话中的选择。
  }
  return normalized;
};
